<h3 style="color: white; margin-left:10px;">Event</h3>
<form [formGroup]="addEventForm" (ngSubmit)="save()">
  <mat-dialog-content style="font-family: Roboto;background-color: #303030;">


    <input name="EventId" type="hidden" formControlName="EventId" />

    <mat-form-field class="example-full-width">
      <input matInput placeholder="Title" formControlName="Title" />
    </mat-form-field>
    <br />
    <mat-form-field style="width: 100%;">
      <textarea matInput placeholder="Comment" formControlName="Comment" cdkAutosizeMinRows="3"
      cdkAutosizeMaxRows="10"></textarea>
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Choose a date</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="EventDate">
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    &nbsp;
    <mat-form-field>
      <mat-label>Start time</mat-label>
      <input matInput type="time" placeholder="Start time" formControlName="EventTime" />
      <mat-hint>Timezone:{{this.displayTimeZone}}</mat-hint>
    </mat-form-field>&nbsp;
    <br />
    <mat-form-field>
      <mat-label>Choose a end date</mat-label>
      <input matInput [matDatepicker]="pickerEnd" formControlName="EventEndDate">
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
      <mat-datepicker #pickerEnd></mat-datepicker>
    </mat-form-field>
    &nbsp;
    <mat-form-field>
      <mat-label>End time</mat-label>
      <input matInput type="time" placeholder="Ent time" formControlName="EventEndTime" />
      <mat-hint>Timezone:{{this.displayTimeZone}}</mat-hint>
    </mat-form-field>&nbsp;
    <br />
    <mat-checkbox formControlName="_PRIVATE">Private</mat-checkbox>
  </mat-dialog-content>
  <mat-dialog-actions>
    @if ((isUpdate && this.theEvent.IsMyEvent) || !this.isUpdate) {
      <button mat-button type="submit"
      [disabled]="!this.addEventForm.valid">SAVE</button>
    }
    <button mat-button [mat-dialog-close]="false">CLOSE</button>
  </mat-dialog-actions>
</form>